import React from 'react';
import PropTypes from 'prop-types';

import { Panel } from 'react-bootstrap';

import ManagedInput from 'components/form/managed_input';
import UserSelector from './user_selector';

export default function CompanyGridUsers({ companyGrid, users, onChange }) {
  return <React.Fragment>
    <Panel className="company-grid-filter-users-panel">
      <Panel.Body>
        <ManagedInput
          checked={companyGrid.enabledForAllUsers}
          name="enabledForAllUsers"
          type="checkbox"
          onChange={onChange}
        >
          Enable for all users
        </ManagedInput>
        <p>Unchecking will allow you to grant access to this grid template on a per-user basis.</p>
      </Panel.Body>
    </Panel>

    {!companyGrid.enabledForAllUsers && (
      <UserSelector
        key="user-selector"
        selectedUserIds={companyGrid.enabledUserIds}
        users={users}
        onChange={enabledUserIds => onChange({ enabledUserIds })}
      />
    )}
  </React.Fragment>;
}

CompanyGridUsers.propTypes = {
  companyGrid: PropTypes.shape({
    enabledForAllUsers: PropTypes.bool,
    selectedUserIds: PropTypes.array,
  }).isRequired,
  users: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
